import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {EnumFiltroDePedidos, PedidosService} from "../../services/pedidos.service";
import {GridPedidosComponent} from "../grid-pedidos/grid-pedidos.component";
import {ImpressaoService} from "../../services/impressao.service";
import {Subscription} from "rxjs";

declare var moment;

@Component({
  selector: 'app-tela-pedidos-cancelados',
  templateUrl: './tela-pedidos-cancelados.component.html',
  styleUrls: ['./tela-pedidos-cancelados.component.scss']
})
export class TelaPedidosCanceladosComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('gridPedidos', { static: true}) gridPedidos: GridPedidosComponent;
  pedidos: [];
  paginacao = { total: 1000};
  carregando: any = false;
  timerBusca: any;
  filtro: any = { inicio: null, fim: null};
  resumoPedidos: any = { qtde: 0, total: 0, totalTaxas: 0 };
  @Input() mesa = false;
  @Input() empresa: any = {};
  objFiltro: any = {
    q: '',
    filtroImpressao: null
  };
  opcoesFiltroImpressao: any[] = [{id: 0, descricaoFiltro: 'Não impressos nunca'}];
  private inscricaoPedidoImpresso: Subscription;

  constructor(private pedidosService: PedidosService, private impressaoService: ImpressaoService) {
  }

  ngOnInit(): void {
    this.filtro.inicio = moment().add(-7 , 'd').toDate();
    this.filtro.fim = new Date();
    this.inscricaoPedidoImpresso = this.impressaoService.onPedidoImpresso.subscribe((dados: any) => {
      const idImpressora = this.obtenhaIdImpressoraFiltro();
      if(this.objFiltro.filtroImpressao === 0 ||
        (idImpressora && Number(dados?.impressora?.id) === idImpressora))
        this.carreguePedidos();
    });
    this.carreguePedidos();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.empresa)
      this.atualizeOpcoesFiltroImpressao();
  }

  ngOnDestroy() {
    if(this.inscricaoPedidoImpresso)
      this.inscricaoPedidoImpresso.unsubscribe();
  }

  private atualizeOpcoesFiltroImpressao() {
    const impressoras = this.empresa?.configImpressao?.impressoras || [];
    this.opcoesFiltroImpressao = [
      {id: 0, descricaoFiltro: 'Não impressos nunca'},
      ...impressoras
      .filter((impressora: any) => impressora && !impressora.removida)
      .map((impressora: any) => ({
        id: impressora.id,
        descricaoFiltro: `Não impressos em "${impressora.setor || impressora.nome}"`
      }))
    ];
  }

  carreguePedidos(){
    if(this.carregando) return;

    let dtInicio = moment(this.filtro.inicio).format('YYYYMMDD');
    let dtFim = moment(this.filtro.fim).format('YYYYMMDD');

    this.carregando = true;
    let filtro = EnumFiltroDePedidos.pedidos;
    if( this.mesa ) {
      filtro = EnumFiltroDePedidos.comanda;
    }
    this.pedidosService.listePedidosCancelados(0, this.paginacao.total,
      null, dtInicio, dtFim, filtro, this.objFiltro.q,
      this.obtenhaIdImpressoraFiltro()).then( (resposta) => {
      this.setPedidos(this.filtrePedidos(resposta.pedidos || []));

      this.gridPedidos.atualizeGridPedidos(this.pedidos, 'cancelados');
      this.carregando = false;
    }).catch( () => {
      this.carregando = false;
    });
  }

  private setPedidos(resposta: any) {
    this.pedidos = resposta || [];
    this.resumoPedidos.qtde = this.pedidos.length;


  }

  private filtrePedidos(pedidos: any) {
    if(this.objFiltro.filtroImpressao === 0)
      return pedidos.filter((pedido: any) => !pedido.impresso);

    return pedidos;
  }

  private obtenhaIdImpressoraFiltro(): number {
    const idImpressora = Number(this.objFiltro.filtroImpressao);
    return Number.isInteger(idImpressora) && idImpressora > 0 ? idImpressora : null;
  }

  onFilter($event: any) {
    if(this.timerBusca) clearTimeout(this.timerBusca);

    this.timerBusca = setTimeout(() => {
      this.carreguePedidos();
    }, 1000);
  }
}
